import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import styled from 'styled-components';
import { Button, Row, Column, DropdownInput } from '@dls/web';
import { setMock, resetMock, selectMock } from './mockSlice';
import { MOCK_HOST } from '../../config/constants';

const StyledMock = styled.div``;

type Props = {
  onClose: () => void;
  appName: string;
};

export const Mock = ({ onClose, appName }: Props) => {
  const [scenarioGroups, setScenarioGroups] = useState(null);
  const mock = useSelector(selectMock);
  const dispatch = useDispatch();

  const fetchData = async () => {
    try {
      const response = await fetch(`${MOCK_HOST}/mock/scenarioGroups`, {
        headers: { 'dt-app': appName }
      }).then((res) => res.json());

      /* @ts-ignore */
      let scenarioGroupOptions = response.map((res) => ({
        name: res.name,
        value: res.value
      }));

      /* @ts-ignore */
      let scenario = response.reduce((acc, cur) => {
        if (!(cur.value in acc)) {
          acc[cur.value] = cur.scenarios;
        }

        return acc;
      }, {});

      let formatted = [
        {
          id: 'scenario-group',
          name: 'scenario-group',
          text: 'Scenario Group',
          type: 'DROPDOWN',
          values: scenarioGroupOptions
        },
        {
          id: 'scenario',
          name: 'scenario',
          text: 'Scenario',
          type: 'DROPDOWN',
          parent: 'scenario-group',
          value: scenario
        }
      ];

      setScenarioGroups(formatted);
    } catch (error) {
      console.log('Looks like there was a problem: ', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const {
    watch,
    control,
    handleSubmit,
    // formState: { errors },
    getValues,
    setValue,
    reset
  } = useForm({ defaultValues: { ...mock } });

  watch();

  const handleReset = () => {
    reset();
    dispatch(resetMock());
    onClose();
  };

  const onSubmit = handleSubmit((data) => {
    if (Object.values(data).some((val) => val)) {
      dispatch(setMock(data));
      onClose();

      window.location.reload();
    }
  });

  return (
    <StyledMock>
      {scenarioGroups?.map(
        (item: {
          type: string;
          name: string;
          values: object[];
          parent?: string;
          text: string;
          id: number;
          value: {
            [key: string]: [];
          };
        }) => {
          if (item.type === 'DROPDOWN') {
            return (
              <Row>
                <Column>
                  <Controller
                    /* @ts-ignore */
                    name={item.name}
                    control={control}
                    render={({ field }) => {
                      const { value, ...rest } = field;
                      const values = getValues();

                      let items = item.values
                        ? item.values.map((itm: { name: string }) => ({
                            ...itm,
                            text: itm.name
                          }))
                        : [];

                      if (
                        item.parent &&
                        /* @ts-ignore */
                        values[item.parent] &&
                        /* @ts-ignore */
                        values[item.parent].value
                      ) {
                        /* @ts-ignore */
                        items = item.value[values[item.parent].value].map(
                          (itm: { name: string }) => ({
                            ...itm,
                            text: itm.name
                          })
                        );
                      }

                      return (
                        <DropdownInput
                          zIndex={100000}
                          {...rest}
                          label={`Select ${item.text}`}
                          bgColor="haze"
                          items={items}
                          /* @ts-ignore */
                          value={values[item.id] ? values[item.id].value : null}
                        />
                      );
                    }}
                  />
                </Column>
              </Row>
            );
          }
        }
      )}

      <Row>
        <Column xs={6}>
          <Button
            fullWidth
            secondary
            data-testid="reset-button"
            text="Reset"
            onClick={handleReset}
          />
        </Column>
        <Column xs={6}>
          <Button
            fullWidth
            data-testid="confirm-button"
            text="Confirm"
            onClick={onSubmit}
          />
        </Column>
      </Row>
    </StyledMock>
  );
};
